import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { appendHttpParamsFromObject, convertISOToDateOnly, TreetopPropertiesProvider } from 'shared/util-common';

import { OrganisationDto, OrganisationStatistics } from '@treetop/shared/model';

export interface OrganisationStatisticsRequest {
  organisationId: string;
  fromDate: Date;
  toDate: Date;
  compareToFromDate: Date;
  compareToToDate: Date;
  includeOrganisationTree?: boolean;
}

/**
 * Cross-organisation statistics, only available to Treetop administrators.
 */
@Injectable({ providedIn: 'root' })
export class AdminStatisticsHttpService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/admin/statistics`;

  public getOrganisations(): Observable<OrganisationDto[]> {
    return this.http.get<OrganisationDto[]>(`${this.baseUrl}/organisations`);
  }

  public getOrganisationStatistics(request: OrganisationStatisticsRequest): Observable<OrganisationStatistics> {
    let params = appendHttpParamsFromObject(
      {
        fromDate: convertISOToDateOnly(request.fromDate),
        toDate: convertISOToDateOnly(request.toDate),
        compareToFromDate: convertISOToDateOnly(request.compareToFromDate),
        compareToToDate: convertISOToDateOnly(request.compareToToDate),
      },
      new HttpParams(),
    );

    if (request.includeOrganisationTree) {
      params = params.set('includeOrganisationTree', 'true');
    }

    return this.http.get<OrganisationStatistics>(`${this.baseUrl}/organisations/${request.organisationId}`, { params });
  }
}
